import { useSetState } from 'ahooks'
import { Checkbox } from 'antd-mobile'
import { throttle } from 'lodash-es'
import { observer } from 'mobx-react-lite'
import React, { useEffect, useMemo } from 'react'

import { SELECT_MODE } from '@/constants'
import { isNotEmptyArray } from '@/utils'

import { HSearchBar, HPopup } from '../'

import './index.less'

interface HSearchViewProps {
  mode?: 'multiple' | 'single' | 'view'
  title?: string
  selectedList?: any[]
  count?: number
  onRemove?: (item: any, list: any[]) => void
  onAllSelectedChange?: (flag: boolean) => void
  onConfirm?: (selectedList: any[]) => void
  onKeywordChange?: (keyword: string) => void
  [key: string]: any
}

const HSearchView: React.FC<HSearchViewProps> = ({
  mode = SELECT_MODE.SINGLE,
  count = 1,
  title = '已选',
  keyword = '',
  selectedList = [],
  allSelected = false,
  onKeywordChange,
  onRemove,
  fieldNames = { label: 'name', value: 'id' },
  onConfirm,
  onAllSelectedChange,
  ...props
}) => {
  const [{ selected, show }, setState] = useSetState<any>({
    show: false,
    selected: false
  })

  // 是否可选择
  const selectable = mode !== SELECT_MODE.VIEW

  // 搜索
  const onSearchChange = (str: string) => {
    const start = throttle(async () => {
      onKeywordChange?.(str?.trim())
    }, 800)
    start()
  }

  // 移除
  const handleRemove = (item: any) => {
    onRemove?.(
      item,
      selectedList?.filter((x: any) => x?.[fieldNames?.value] !== item?.[fieldNames?.value])
    )
  }

  // 是否有数据
  const hasData = isNotEmptyArray(selectedList)

  // 总数量
  const allCount = useMemo(() => {
    return mode === SELECT_MODE.SINGLE ? 1 : count
  }, [count, mode])

  useEffect(() => {
    setState({ selected: allSelected })
  }, [allSelected])

  return (
    <div className={`h-search-view h-search-view-${mode} ${props?.className || ''}`}>
      <div className='h-search-view-header'>
        <div className='h-search-view-search'>
          <HSearchBar onChange={onSearchChange} value={keyword} />
        </div>
        {props?.header}
        {mode === 'multiple' && (
          <div className='h-tree-select-all'>
            <Checkbox checked={selected} onChange={onAllSelectedChange}>
              全选
            </Checkbox>
          </div>
        )}
      </div>

      <div className='h-search-view-main'>{props?.children}</div>

      {selectable && (
        <>
          <div className='h-search-view-selected'>
            <div
              className='h-search-view-selected-count-wrap'
              onClick={() => hasData && setState({ show: true })}
            >
              已选择 （
              <span className='h-search-view-selected-count'>{selectedList?.length || 0}</span>/
              {allCount}）
            </div>
            <div
              className='h-search-view-selected-confirm'
              onClick={() => onConfirm?.(selectedList)}
            >
              确定
            </div>
          </div>
          <HPopup
            title={title}
            visible={show}
            closeOnMaskClick
            showCloseButton
            className='h-search-view-sheet-popup'
            hasOk={false}
            hasCancel={false}
            onClose={() => {
              setState({ show: false })
            }}
          >
            <div className='h-search-view-sheet'>
              {hasData &&
                selectedList?.map((x: any, index: number) => {
                  const label = x?.[fieldNames?.label] || x?.name
                  const value = x?.[fieldNames?.value] || x?.id
                  return (
                    <div key={`${value}-${label}-${index}`} className='h-search-view-sheet-item'>
                      <div className='h-search-view-sheet-item-name van-ellipsis-1'>{label}</div>
                      <div
                        className='h-search-view-sheet-item-remove'
                        onClick={() => {
                          handleRemove?.(x)
                        }}
                      >
                        移除
                      </div>
                    </div>
                  )
                })}
            </div>
          </HPopup>
        </>
      )}
    </div>
  )
}

export default observer(HSearchView)
